module.exports = __webpack_public_path__ + "img/cjfwU16.0050caf9.png";